// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);

import HeaderMenuController from "./header_menu_controller";
application.register("header-menu", HeaderMenuController);

import PasswordToggleController from "./password_toggle_controller";
application.register("password-toggle", PasswordToggleController);
